<template>
  <div class="select-company">
    <Header />
    <div class="main-wrap">
      <div class="content">
        <p class="content-tip">请选择要查看的企业：</p>
        <ul class="company-list">
          <li v-for="item in companyList" :key="item.tenantId" class="company-item">
            <div class="company-item-info">
              <p class="company-item-name">{{ item.companyName }}</p>
            </div>
            <a class="company-item-action" :clstag="`pageclick|keycount|login_04|${item.companyName}`" @click="selectCompany(item)">立即进入</a>
          </li>
        </ul>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/layout/header.vue';
import Footer from '@/components/layout/footer.vue';
import { getCompanyList, selectCompany } from '@/api/apis/company';
import { isJMSupportQY } from '../../utils/jmsdk';

export default {
  name: 'SelectCompany',
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      companyList: [],
    };
  },
  mounted() {
    this.getCompanyList();
  },
  methods: {
    async getCompanyList() {
      const { code, data, message } = await getCompanyList();

      if (code === 200) {
        this.companyList = data.tenantList;
      } else {
        this.$message.error(message || '服务器异常，请稍后重试');
      }
    },
    async selectCompany(item) {
      const { companyName, tenantId } = item;

      const { code, message } = await selectCompany({
        tenantId,
      });

      // 选择公司后，进入企业工作台首页
      if (code === 200) {
        this.$router.push({
          name: 'Home',
        });
        // 如果是在京麦客户端中，且京麦支持企业账号，则使用京麦的修改企业的接口，通知客户端修改 title
        if (isJMSupportQY) {
          window.jmsdkPC.changeCompany({
            id: tenantId,
            name: companyName,
          });
        }
      } else {
        this.$message.error(message || '服务器异常，请稍后重试');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.select-company {
  .main-wrap {
    width: 1260px;
    margin: 20px auto 0;
    padding: 55px 0;
    min-height: calc(100vh - 168px - 100px);
    box-sizing: border-box;
    background: #fff;
    border-radius: 2px;
  }
  .content {
    width: 840px;
    margin: 50px auto;
  }
  .content-tip {
    font-size: 14px;
    line-height: 20px;
    color: rgba(89,89,89,1);
    margin: 0 0 27px;
  }
  .company-list {
    margin: 0;
    list-style: none;
    font-size: 0;
  }
  .company-item {
    display: inline-block;
    margin: 0 30px 30px 0;
    width: 260px;
    border: 1px solid #e9e9e9;
    border-radius: 8px;
    font-size: 14px;
    box-sizing: border-box;
    vertical-align: top;
    transition: box-shadow .3s ease-in-out;
    cursor: pointer;
    overflow: hidden;

    &:nth-child(3n) {
      margin-right: 0;
    }
    &:hover {
      box-shadow:  0 2px 8px 0 rgba(0,0,0,0.08);
    }
  }
  .company-item-info {
    height: 130px;
    text-align: center;
  }
  .company-item-name {
    font-size: 16px;
    color: #262626;
    line-height: 1.25;
    padding-top: 48px;
  }
  .company-item-id {
    color: #8c8c8c;
    line-height: 1.428;
    margin-top: 7px;
  }
  .company-item-action {
    display: block;
    height: 48px;
    line-height: 48px;
    text-align: center;
    color: #4D80F0;
    font-size: 14px;
    background: #F7F7F7;

    &:hover {
      color: #5AA0FF;
    }
  }
}
</style>
